import React from "react";
import { validateAccess } from "../../utilities/validateNavigation";

interface IValidateNavigation {
  href: string;
  accessId: string;
  customClassName?: any;
  children: React.ReactNode;
}

const ValidateNavigation = ({
  href,
  accessId,
  customClassName,
  children,
}: IValidateNavigation) => {
  return (
    <button
      onClick={() => {
        // Valida el permiso ANTES de navegar: si no tiene acceso, validateAccess
        // dispara el evento "access-denied" (modal de no autorizado) y NO navega.
        // Si tiene acceso (o la opción no requiere permiso), navega.
        validateAccess(href, accessId);
        setTimeout(() => document.body.click(), 0);
      }}
      className={customClassName}
    >
      {children}
    </button>
  );
};

export default ValidateNavigation;
